module.exports = __webpack_public_path__ + "img/progress_circle.be6d4b07.gif";